import { SvgIconProps } from '@traba/types'

export function Sunrise({
  size,
  color = '#7A8A99',
  strokeWidth = '1.5',
  ...rest
}: SvgIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M2 10.4286H14M4.57143 13H11.4286M4.57143 10.4286C4.57143 8.53502 6.10645 7 8 7C9.89355 7 11.4286 8.53502 11.4286 10.4286H4.57143Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M7.99999 3.00016V2.3335M11 3.70829L10.3748 4.3335M5.62521 4.3335L5 3.70828"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
